import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'

const useBulkRemoveRooms = ({
  onSuccess,
  onError
}: {
  onSuccess: (data: {
    successfully_deleted: number
    unsuccessfully_deleted: number
  }) => void
  onError: () => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: async (data: { ids: string[] }) =>
      httpService.panel.panelRoomsBulkDeleteCreate({
        rooms_ids: data.ids
      }),
    onSuccess: response => onSuccess?.(response),
    onError
  })

export default useBulkRemoveRooms
